import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-payment-redirection',
    templateUrl: './payment-redirection.component.html',
    styleUrls: ['./payment-redirection.component.css'],
    standalone: false
})
export class PaymentRedirectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
